import React from 'react';
import { ShieldCheck, Video, Maximize, MapPin, Clock, Key } from 'lucide-react';
const features = [{
  icon: Video,
  title: '24/7 Video Monitoring',
  description: 'State-of-the-art CCTV system covering all angles of the facility for complete peace of mind.'
}, {
  icon: ShieldCheck,
  title: 'Secure Gated Access',
  description: 'The facility will feature gated access and perimeter fencing. We may have an on-site resident caretaker to help monitor the property.'
}, {
  icon: Maximize,
  title: 'Spacious Bays',
  description: 'Generously sized storage bays designed to accommodate caravans, boats and motorhomes of all sizes.'
}, {
  icon: MapPin,
  title: 'Easy Access',
  description: 'Wide driveways and turning circles make parking your vehicle stress-free and simple.'
}, {
  icon: Clock,
  title: 'Flexible Terms',
  description: 'Month-by-month, no long fixed term agreements, tailored to suit your travel plans.'
}, {
  icon: Key,
  title: 'Self Storage',
  description: 'Access your vehicle whenever you need it with our convenient access hours.'
}];
export function Features() {
  return <section id="features" className="pt-10 pb-20 bg-white" data-id="element-167">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-168">
        <div className="text-center mb-16" data-id="element-169">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-gray-900 mb-4" data-id="element-170">
            Why Choose <span className="text-[#1A7B7E]" data-id="element-171">HOLDMYVAN?</span>
          </h2>
          <div className="h-1 w-24 bg-[#FFC107] mx-auto rounded-full" data-id="element-172"></div>
          <p className="mt-4 text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-173">
            We provide low cost, secure storage solutions designed specifically
            for caravan, boat and motorhome owners in Perth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-174">
          {features.map((feature, index) => <div key={index} className="group p-8 border border-gray-100 rounded-lg hover:shadow-xl hover:border-[#1A7B7E]/30 transition-all duration-300 bg-gray-50 hover:bg-white" data-id="element-175">
              <div className="inline-flex items-center justify-center p-3 bg-[#1A7B7E]/10 text-[#1A7B7E] rounded-lg mb-6 group-hover:bg-[#1A7B7E] group-hover:text-white transition-colors duration-300" data-id="element-176">
                <feature.icon className="h-8 w-8" data-id="element-177" />
              </div>
              <h3 className="text-xl font-display font-bold text-gray-900 mb-3" data-id="element-178">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-179">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}